<div class="container" [class.container--loading-inline]="isLoading() && !isFixedPosition() && variant() === 'redesign'">
    @if (isLoading()) {
        <div class="spinner-content" role="status" aria-live="polite">
            <div
                [ngClass]="{'spinner--fixed': isFixedPosition(), 'spinner--fixed-with-search-panel': isWithSearchPanel(), 'spinner--redesign': variant() === 'redesign'}"
                class="spinner">
                @if (variant() === 'redesign') {
                    <svg-icon class="spinner__icon" src="/assets/icons/spinner.svg" aria-hidden="true"></svg-icon>
                }
            </div>
        </div>
    }
    <ng-content></ng-content>
</div>
